<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="remove()">
      <v-icon color="pink">remove_circle</v-icon>
    </v-btn>
    <span>Remove</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    remove() {
      this.$emit("remove");
    }
  }
};
</script>

<style>
</style>
